import Vue from 'vue';
import Delta from './../ux/Delta';
import Spinner from "./../ux/Spinner";
import MonthPicker from './../ux/MonthPicker';
import DatePicker from './../ux/DatePicker';
import LastAvailableDataDateLabel from './../ux/LastAvailableDataDateLabel';
import {mapState} from "vuex";

export default {
  components: {
    MonthPicker,
    DatePicker,
    Delta,
    Spinner,
    LastAvailableDataDateLabel,
  },

  data: () => ({
    setDateFromResponse: false,
    dateFromResponse: null,
    dateComparisonType: 'day',
    loading: false,
  }),

  computed: {
    ...mapState({
      stateSelectedSiteId: state => state.selectedSiteId,
    }),

    isLockWidgets: {
      get() {
        return this.$store.state.dashboard.isLocked;
      },
      set(isLocked) {
        this.$store.dispatch('dashboard/setIsLocked', isLocked);
      }
    },

    lockedDate: {
      get() {
        return this.$store.state.dashboard.lockedDate;
      },
      set(lockedDate) {
        this.$store.dispatch('dashboard/setLockedDate', lockedDate);
      }
    },

    date: {
      get() {
        if (! this.isLockWidgets) {
          return this.localDate;
        }

        return this.widgetLockedDate;
      },
      set(value) {
        if (this.isLockWidgets) {
          this.lockedDate = value;
        } else {
          this.localDate = value;
        }
      },
    },

    widgetLockedDate() {
      return this.lockedDate;
    },
  },

  watch: {
    stateSelectedSiteId() {
      this.loadData(true);
    },

    date (newValue, oldValue) {
      // This condition for widgets that doesn't depend on any 'date' as 'Weather'
      if(! newValue || ! oldValue) {
        return;
      }

      if (this.setDateFromResponse) {
        this.dateFromResponse = newValue;
        this.setDateFromResponse = false;

        if (this.$options.name) {
          this.$store.dispatch(`dashboard/setMaxDateFromResponse`, { widget: this.$options.name, date: this.dateFromResponse });
        }

        return;
      }

      if (! newValue.isSame(oldValue, this.dateComparisonType)) {
        this.loadData();
      }
    },

    lockedDate() {
      if (this.isLockWidgets) {
        this.localDate = this.widgetLockedDate;
      }
    },
  },

  async mounted () {
    if(! this.dateFromResponse && this.$options.name) {
      const maxDateFromResponse = this.$store.state.dashboard.maxDateFromResponse[this.$options.name];

      if (maxDateFromResponse) {
        this.dateFromResponse = maxDateFromResponse;
      }

      if (this.dateFromResponse && this.dateFromResponse < this.localDate) {
        this.localDate = this.dateFromResponse;
      }
    }

    await this.loadData();
  },

  filters: {
    formatNullableDecimal: (value) => {
      if (value === null || value === undefined) {
        return '-';
      }

      return Vue.filter('formatDecimal')(value);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/VectorWidgets/widgets/vector.js